import {
  InitClient,
  GetByParas,
  Post
} from "../ZeusAPIClient.js";
import {
  apiConfig
} from "../../config.js";

export let key = InitClient(
  apiConfig.clientId,
  apiConfig.clientSecret,
  apiConfig.host
);

/**
 * 获取客户档案列表
 * {
  *"Predicates": [{
  *  "Field": "IsDel",
  *  "Value": "0",
  *  "Oper": "eq",
  *  "IsAnd": 1
  *}],
  *"PageIndex": 1,
  *"PageSize": 20,
  *"OrderBy": "AddTime",
  *"Sort": "desc"
}
 */
async function GetCustomerProfile(data) {
  let paras = {
    ...data
  };
  return await GetByParas("973443ea-2106-4e88-b706-7fb8f860607d", paras);
}
/**
 * 获取客户档案
 */
 async function GetCustomerInfo(data) {
  return await GetByParas("4548eb1a-ffed-458a-b75d-742d627979fe", data);
}
/**
 * 新增/修改客户档案
 */
async function MaintainCustomerDoc(data) {
  return await Post("462660dc-5728-4f93-a447-8fa6cf4b0f16", data);
}
/**
 * 删除客户档案列表
 * @params restful
 * */
async function DeleteCustomerProfile(data) {
  let paras = {
    ID: data
  };
  return await GetByParas(`2ec36cac-9fc1-457b-97a8-2ac2061fa916`, paras);
}

/**
 * 导出全部客户档案
 */
function ExportAllCustomer() {
  return `${key}/api/customerinfo/exporttoinfo`;
}

/**
 * 获取一级、二级行业内容
 * */
async function getIndustryList(data) {
  let paras = {
    ...data
  };
  return await GetByParas("9e4f7568-f3a4-472f-b3a0-7166f6b48ab3", paras);
}

// 获取 出访复盘 推广提案 优化诊断
async function getCustomerDetail(data) {
  let paras = {
    ...data
  };
  return await GetByParas("eec28b5c-8f59-41c2-9cbb-a1fc7c6a7dc4", paras);
}
// 新增、修改 出访复盘 推广提案 优化诊断
async function addCustomerDetail(data) {
  return await Post("2f2d2072-f8bd-4fb3-b5c3-fa42717a7c49", data);
}
// 删除 出访复盘 推广提案 优化诊断
async function delCustomerDetail(data) {
  let paras = {
    ...data
  };
  return await GetByParas("d2461e26-26b2-476c-bad2-d9d231d446ca", paras);
}
// 获取评分
async function getCustomerMark(data) {
  let paras = {
    customerid: data
  };
  return await GetByParas("f4b8ced8-3cde-42c1-9028-affbefc068cb", paras);
}
// 设置客户综合评分
async function SetCustomerScore(data) {
  return await Post("d3187df8-e411-4bbd-b568-beaea7ee5a77", data);
}
// 导入客户数据
async function AddCustomer(data) {
  return await Post("02879ed9-1392-4226-936c-7088257ba5f6", data);
}
export {
  GetCustomerProfile,
  GetCustomerInfo,
  DeleteCustomerProfile,
  MaintainCustomerDoc,
  ExportAllCustomer,
  getIndustryList,
  getCustomerDetail,
  getCustomerMark,
  addCustomerDetail,
  delCustomerDetail,
  SetCustomerScore,
  AddCustomer
};